import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog';
import { create } from 'zustand';

/**
 * X8 — 연결 불안정 팝업 (Figma 848:9233). 앱 루트에 한 번만 둔다.
 * 3초 뒤 사라지던 토스트가 [확인]을 눌러야 닫히는 팝업으로 바뀌었다 (기획 ↔ 디자인 변경 9).
 * 여러 요청이 한꺼번에 실패해도 열림 상태 하나만 두므로 팝업은 하나만 뜬다.
 */
const useNetworkErrorStore = create<{ open: boolean }>(() => ({
  open: false,
}));

// eslint-disable-next-line react-refresh/only-export-components
export const openNetworkErrorDialog = () =>
  useNetworkErrorStore.setState({ open: true });

export const NetworkErrorDialog = () => {
  const open = useNetworkErrorStore((s) => s.open);
  return (
    <AlertDialog
      open={open}
      onOpenChange={(o) => useNetworkErrorStore.setState({ open: o })}
    >
      <AlertDialogContent>
        <AlertDialogTitle>연결이 불안정해요</AlertDialogTitle>
        <AlertDialogDescription>
          잠시 후 다시 시도해주세요.
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogAction>확인</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
